






















































































import { Component, Prop, PropSync, Vue, Watch } from 'vue-property-decorator';
//@ts-ignore
import { shiftDataStore } from '@/store/theoryApiStore/shiftDataModule.ts';

@Component
export default class PopupCard extends Vue {
  @PropSync('selectedOpenValue', {type: Boolean, required: true})
  public selectedOpen!: boolean;

  @Prop({required: false})
  public selectedEventId!: string;

  @Prop({required: true, type: Function})
  public hideShiftMenu!: () => void;

  @Prop({required: false, type: Function})
  public changeActivator!: () => void;

  @Prop({required: false, type: Boolean, default: false})
  public isWeeklyView!: boolean;

  @Prop({required: false, type: Function})
  public scrollToTime!: (time: number | string | { hour: number, minute: number }) => void;

  private selectedDate: string = "2000-04-01";

  private selectedStartTime: string = "10:00";
  private selectedEndTime: string = "19:00";

  private selectedMember: string = "従業員太郎"

  get event() {
    if (!this.selectedEventId) return {}
    return shiftDataStore.getSingleEventForCalendar(this.selectedEventId)
  }

  @Watch('selectedOpen')
  private onUpdateSelectedOpen(newValue: boolean, oldValue: boolean) {
    if (newValue && !oldValue) {
      this.setFormValue()
    }
  }

  mounted() {
    // シフト提出メニューの初回表示時に表示すべき値をセットする
    this.setFormValue()
  }

  onChangeTime() {
    const start = new Date(`${this.selectedDate}T${this.selectedStartTime}:00`)
    const end = new Date(`${this.selectedDate}T${this.selectedEndTime}:00`)
    if (start.getTime() > end.getTime()) {
      end.setTime(end.getTime() + 86400000);
    }
    shiftDataStore.updateEvent({
      eventId: this.selectedEventId,
      start,
      end,
      name: this.selectedMember
    });
    if (this.isWeeklyView) {
      this.scrollToTime({
        hour: start.getHours(),
        minute: start.getMinutes()
      });
      this.changeActivator();
    }
  }

  onChangeMember() {
    const start = new Date(`${this.selectedDate}T${this.selectedStartTime}:00`)
    const end = new Date(`${this.selectedDate}T${this.selectedEndTime}:00`)
    shiftDataStore.updateEvent({
      eventId: this.selectedEventId,
      start,
      end,
      name: this.selectedMember
    });
  }

  onChangeDate() {
    const start = new Date(`${this.selectedDate}T${this.selectedStartTime}:00`)
    const end = new Date(`${this.selectedDate}T${this.selectedEndTime}:00`)
    shiftDataStore.updateEvent({
      eventId: this.selectedEventId,
      start,
      end,
      name: this.selectedMember
    });
    this.changeActivator();
  }

  private setFormValue() {
    let startDate: Date = this.event.start;
    let endDate: Date = this.event.end;
    const intervalId = setInterval(() => {
      startDate = this.event.start;
      endDate = this.event.end;
      if (startDate && endDate) {
        clearInterval(intervalId);
        this.selectedDate = `${startDate.getFullYear()}-${`00${startDate.getMonth() + 1}`.slice(-2)}-${`00${startDate.getDate()}`.slice(-2)}`
        this.selectedStartTime = `${`00${startDate.getHours()}`.slice(-2)}:${`00${startDate.getMinutes()}`.slice(-2)}`;
        this.selectedEndTime = `${`00${endDate.getHours()}`.slice(-2)}:${`00${endDate.getMinutes()}`.slice(-2)}`;
        this.selectedMember = this.event.name;
      }
    }, 10)
  }



  private memberItems: string[] = [
    '担当未設定',
    'Member 1',
    'Member 2'
  ]
  private repititionChoiceItems: string[] = [
    '繰り返さない',
    '毎日',
    '毎週月曜日',
    '毎月第2月曜日',
    '毎週平日',
    'カスタム'
  ]

  private startTimeChoiceItems: string[] = (() => {
    const arr = new Array<string>(96);
    for (let index = 0; index < arr.length; index++) {
      const hour = Math.floor(index / 4);
      const minute = (index % 4) * 15;
      arr[index] = `${`00${hour}`.slice(-2)}:${`00${minute}`.slice(-2)}`
    }
    return arr
  })();

  private endTimeChoiceItems: string[] = (() => {
    const arr = new Array<string>(96);
    for (let index = 0; index < arr.length; index++) {
      const hour = Math.floor(index / 4);
      const minute = (index % 4) * 15;
      arr[index] = `${`00${hour}`.slice(-2)}:${`00${minute}`.slice(-2)}`
    }
    return arr
  })();
}
